import styled from "styled-components/macro";

export default styled.div`
  .services-container {
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    text-align: center;
    padding: 60px 20px 80px 20px;
    min-height: auto;
    position: relative;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(circle at 20% 80%, rgba(1, 183, 255, 0.1) 0%, transparent 50%),
                  radial-gradient(circle at 80% 20%, rgba(68, 240, 181, 0.1) 0%, transparent 50%);
      pointer-events: none;
    }
  }

  .service-item {
    padding: 20px;
    display: flex;
    justify-content: center;
  }

  .service-card {
    background: ${({ theme }) => theme?.colors?.["0"]};
    border-radius: 20px;
    padding: 40px 30px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    position: relative;
    overflow: hidden;
    height: 100%;
    max-width: 350px;
    width: 100%;
    animation: fadeInUp 0.6s ease forwards;
    opacity: 0;
    transform: translateY(30px);
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(1, 183, 255, 0.1),
        transparent
      );
      transition: left 0.6s ease;
    }
    
    &:hover {
      transform: translateY(-15px) scale(1.03);
      box-shadow: 0 25px 60px rgba(1, 183, 255, 0.2);
      
      &::before {
        left: 100%;
      }
      
      .service-icon .MuiAvatar-root {
        transform: scale(1.1) rotate(5deg);
        background: linear-gradient(135deg, ${({ theme }) => theme?.colors?.["2"]} 0%, ${({ theme }) => theme?.colors?.["3"]} 100%);
      }
      
      .service-title {
        color: ${({ theme }) => theme?.colors?.["2"]};
      }
    }
  }

  .service-icon {
    margin-bottom: 25px;
    
    .MuiAvatar-root {
      margin: 0 auto;
      transition: all 0.4s ease;
      box-shadow: 0 8px 25px rgba(1, 183, 255, 0.3);
    }
  }

  .service-content {
    text-align: center;
  }

  .service-title {
    font-size: ${({ theme }) => theme?.fonts?.["4"]};
    font-family: ${({ theme }) => theme?.fontFamily?.["1"]};
    font-weight: 600;
    color: ${({ theme }) => theme?.colors?.["1"]};
    margin: 0 0 15px 0;
    transition: color 0.3s ease;
  }

  .service-desc {
    font-size: ${({ theme }) => theme?.fonts?.["1"]};
    color: ${({ theme }) => theme?.colors?.["5"]};
    line-height: 1.6;
    margin: 0;
    font-family: ${({ theme }) => theme?.fontFamily?.["0"]};
  }

  @keyframes fadeInUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Mobile Responsive */
  @media (max-width: ${({ theme }) => theme?.deviceSize?.mobile}) {
    .services-container {
      padding: 40px 16px 60px 16px;
    }
    
    .service-item {
      padding: 12px;
    }
    
    .service-card {
      padding: 30px 20px;
      max-width: 100%;
      
      &:hover {
        transform: translateY(-8px) scale(1.02);
      }
    }
    
    .service-title {
      font-size: ${({ theme }) => theme?.fonts?.["3"]};
    }
    
    .service-desc {
      font-size: ${({ theme }) => theme?.fonts?.["0"]};
    }
    
    .service-icon .MuiAvatar-root {
      width: 70px !important;
      height: 70px !important;
    }
  }

  /* Tablet Responsive */
  @media (max-width: ${({ theme }) => theme?.deviceSize?.tablet}) {
    .services-container {
      padding: 50px 20px 70px 20px;
    }
    
    .service-item {
      padding: 16px;
    }
    
    .service-card {
      padding: 35px 25px;
    }
  }

  /* Large screens */
  @media (min-width: 1200px) {
    .service-card {
      max-width: 320px;
    }
  }
`;